<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row" style="">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">All documents</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <div class="col-md-12 col-sm-12 ">
            <div class="row">
                <div  class="col-xl-12" style="margin-bottom:20px">
                    <div class="btn btn-outline-primary" (click)="uploadForm()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round" class="feather feather-upload">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="17 8 12 3 7 8"></polyline>
                            <line x1="12" y1="3" x2="12" y2="15"></line>
                        </svg>Upload new document
                    </div>
                    <div *ngIf="isLoading" style="text-align: right" class="clearfix">
                        <div class="spinner-border float-right" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                
                <div *ngIf="!isLoading" class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:20px">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                        <label for="floatingInputValueSubject">Search...</label>
                    </div>
                </div>

            </div>
            <div *ngIf="!isLoading" class="row" style="margin-bottom:10px">
                <div class="col-xl-3 col-md-6 col-xs-6 col-sm-6" *ngFor="let category of formCategories " style="margin-bottom: 10px;">
                    <a (click)="applyCategoryFilter(category.code)" [ngStyle]="{'background-color': category.isActive ? category.active_background_color : category.inactive_background_color, 'color': category.isActive ? category.active_color : category.inactive_color, 'border-color': category.inactive_color }" style="width: 100%; font-size: 13px; height: 35px; margin-right: 20px; font-weight: inherit; color: #00A6B6;" class="btn btn-default">
                        {{category.name}}
                    </a>
                </div>
            </div>
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                    <!-- ID Column -->
                    <ng-container matColumnDef="form">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Shared documents </th>
                        <td mat-cell *matCellDef="let row">
                            <div class="col-md-10 col-sm-10 col-xs-10 no-padding" style="margin-bottom: 10px; margin-top: 10px;">
                                <span class="box-category" style="margin-right:5px">{{row.typeName}}</span>
                                <span style="margin-right:5px">-</span>
                                <span class="box-category" *ngIf="row.folderName == 'Sales'" style="background-color: green; border-radius: 5px; color: white;">Sales</span>
                                <span class="box-category" *ngIf="row.folderName == 'Services'" style="background-color: orange; border-radius: 5px; color: white;">Services</span>
                                <span class="box-category" *ngIf="row.folderName == 'Support'" style="background-color: red;  border-radius: 5px; color: white;">Support</span>
                                <span class="box-category" *ngIf="row.folderName == 'Admin'" style="background-color: blue;  border-radius: 5px; color: white;">Admin</span>
                                <span class="box-category" *ngIf="row.folderName == 'Development'" style="background-color: black;  border-radius: 5px; color: white;">Development</span>
                                <span class="box-category" *ngIf="row.folderName == 'Others'" style="background-color: grey;  border-radius: 5px; color: white;">Others</span>
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px; ">
                                <b>{{row.fileName}}</b>
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom:20px">
                                {{row.description}}
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom:20px; margin-bottom:10px">
                                <span style="float: right; opacity: .5;">Uploaded by <b>{{row.createdByName}}</b> on <b>{{row.createdDate | date : 'medium'}}</b></span>
                            </div>
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr class="table_row" mat-row (click)="clickedRows(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="1">{{loadingMessage}}</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of users"></mat-paginator>
            </div>

        </div>

    </div>

</div>

















<!--<div class="container-fluid">-->
<!--<div class="row">
    <div class="col-xl-3 box-col-4a pe-0" style="padding-left:0">
        <div class="file-sidebar">
            <div class="card">
                <div class="card-body">
                    <ul>
                        <li>
                            <div class="btn btn-outline-primary" (click)="loadFolderDocuments(0, 'All')">
                                All
                            </div>
                        </li>
                        <li *ngFor="let folder of folders">
                            <div class="btn btn-outline-primary" (click)="loadFolderDocuments(folder.id, folder.folderName)">
                                {{folder.folderName}}
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-9 col-md-12 box-col-8" style="padding-right:0">
        <div class="file-content">
            <div class="card">
                <div class="card-header">
                    <div class="media">
                        <h4 class="mb-3">{{selectedFolder}} documents</h4>
                        <div class="media-body text-end">
                            <div class="btn btn-outline-primary" (click)="uploadForm()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                     viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                     stroke-linejoin="round" class="feather feather-upload">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="17 8 12 3 7 8"></polyline>
                                    <line x1="12" y1="3" x2="12" y2="15"></line>
                                </svg>Upload new document
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body file-manager">
                    <div class="form-floating" style="margin-bottom:20px">
                        <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                        <label for="floatingInputValueSubject">Search for document</label>
                    </div>
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="dataSource" matSort style="width:100%">-->

                            <!-- ID Column -->
                            <!--<ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>-->

                            <!-- Progress Column -->
                            <!--<ng-container matColumnDef="fileName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> File </th>
                                <td mat-cell *matCellDef="let row" style="padding-top:10px; padding-bottom:10px">
                                    <small>{{row.type}}</small><br />
                                    {{row.fileName}} <br />
                                    <small>{{row.shortUrl}}</small>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                                <td mat-cell *matCellDef="let row"> {{row.date | date:'medium'}} </td>
                            </ng-container>


                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr class="table_row" mat-row (click)="clickedRows(row)" *matRowDef="let row; columns: displayedColumns;"></tr>-->

                            <!-- Row shown when there is no matching data. -->
                            <!--<tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="3">{{loadingMessage}}</td>
                            </tr>
                        </table>

                        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of documents"></mat-paginator>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>-->
<!--</div>-->
